function formatDate(dateStr) {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "America/Chicago",
  });
}

function Row({ label, value }) {
  if (!value) return null;
  return (
    <div className="gc-modal-row">
      <span className="gc-modal-label">{label}</span>
      <span className="gc-modal-value">{value}</span>
    </div>
  );
}

function GiftcardModal({ giftcard, onClose }) {
  if (!giftcard) return null;

  return (
    <div className="popup-wrapper" onClick={onClose}>
      <div className="popup gc-modal" onClick={(e) => e.stopPropagation()}>
        <div className="gc-modal-header">
          <div className="gc-modal-amount">${giftcard.amount}</div>
          <span className={`gc-modal-badge ${giftcard.isPaid ? "gc-badge-paid" : "gc-badge-unpaid"}`}>
            {giftcard.isPaid ? "Paid" : "Unpaid"}
          </span>
          <button className="gc-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="gc-modal-body">
          <div className="gc-modal-section">
            <div className="gc-modal-section-title">Recipient</div>
            <Row label="Name" value={giftcard.recipientName} />
            <Row label="Email" value={giftcard.email} />
            <Row label="Shipping Address" value={giftcard.shippingAddress} />
          </div>

          <div className="gc-modal-section">
            <div className="gc-modal-section-title">From</div>
            <Row label="Sender Name" value={giftcard.senderName} />
            <Row label="Purchaser Name" value={giftcard.purchaserName} />
            <Row label="Purchaser Email" value={giftcard.purchaserEmail} />
          </div>

          {giftcard.message && (
            <div className="gc-modal-section">
              <div className="gc-modal-section-title">Message</div>
              <div className="gc-modal-message">"{giftcard.message}"</div>
            </div>
          )}

          <div className="gc-modal-section">
            <div className="gc-modal-section-title">Details</div>
            <Row label="Date Purchased" value={formatDate(giftcard.datePurchased)} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default GiftcardModal;
